export default "__VITE_PUBLIC_ASSET__2ce957a8__"